<template>
  <transition name="fade">
    <div class="box">
      <span class="text-justify fs-14 mr-4">
        Nós usamos cookies para melhorar a sua experiência.
        Conheça a nossa
        <a
          class="c-black c-orange-hover no-text-decoration font-weight-bold"
          href="https://construp.com.br/privacidade"
          target="_blank"
        >
          Política de Privacidade.
        </a>
      </span>

      <div>
        <button class="progress-button no-outline" @click="accepted()">
          <span>Prosseguir</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  methods: {
    accepted() {
      this.$cookies.set('accepted_terms', true, '1y');
      this.$emit('accepted');
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  padding: 16px 24px;
  border-radius: 8px;
  width: 100%;
  bottom: 2%;
  background: rgba(255, 255, 255);
  box-shadow: 0 0 15px #222;
}

.progress-button {
  background: #ed670c;
  width: 180px;
  height: 32px;
  border-radius: 4px;
  border: none;
  color: #fff;
}

@media screen and (max-width: 600px) {
  .box {
    flex-direction: column;
  }
  .progress-button {
    margin-top: 16px;
  }
}
</style>
